import React, {Component} from 'react'
import {Card} from 'antd'
import DestinationData from './DestinationData'

class Notifications extends Component {
  render() {
    return (
      <Card title="Notificaciones">
        <DestinationData />
      </Card>
    )
  }
}

export default Notifications



// WEBPACK FOOTER //
// ./src/routes/main/Notifications/index.js